export const OTHER_STORE_GUIDES = {
  nintendo: {
    seoRegions: [
      "Nintendo eShop США",
      "Nintendo eShop Европа",
      "Nintendo eShop Бразилия",
      "Nintendo eShop Канада",
      "Nintendo eShop Гонконг",
      "Nintendo eShop Польша",
      "Nintendo eShop Швеция",
    ],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "С помощью нашего интернет-магазина вы можете легко, просто и удобно купить карты оплаты для Nintendo Switch, пополнить свой кошелёк Nintendo eShop и затем купить любую интересующую вас игру. Или сделать отличный подарок геймеру с помощью подарочных карт Nintendo.",
          ],
          [
            "Перед покупкой обязательно выберите правильный регион. В ",
            {
              link: "https://accounts.nintendo.com/profile/edit",
              text: "личном кабинете Nintendo",
            },
            " в разделе «Страна/регион» укажите нужный регион, а затем купите карту, соответствующую этому региону.",
          ],
        ],
      },
      {
        title: "Подарочная карта Nintendo Gift Card",
        paragraphs: [
          [
            "Карту можно купить сейчас, а активировать когда вам будет удобно — поэтому Nintendo Gift Card часто выбирают в подарок.",
          ],
          [
            "Подарочная карта — это 16-значный код, который вводится в Nintendo eShop на консоли или на ",
            { link: "https://ec.nintendo.com/redeem/#/", text: "сайте Nintendo" },
            ". После активации средства зачисляются на баланс eShop в валюте выбранного региона.",
          ],
          [
            "Способ подходит и для новых, и для уже существующих аккаунтов. Для новых аккаунтов США рекомендуем выбирать штат без дополнительного налога при покупках.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        warning:
          "‼️ Перед входом в eShop убедитесь, что на аккаунте установлен правильный регион.",
        methods: [
          {
            title: "Через сайт",
            steps: [
              [
                "Перейдите на ",
                { link: "https://ec.nintendo.com/redeem/#/", text: "ec.nintendo.com/redeem" },
              ],
              "Вставьте код → Далее → Подтвердите активацию.",
              "Готово — средства на балансе eShop.",
            ],
          },
          {
            title: "Через консоль",
            steps: [
              "Зайдите в eShop с Nintendo Switch.",
              "Выберите свой аккаунт и при необходимости введите пароль.",
              "Прокрутите вниз до пункта Enter Code.",
              "Введите код → OK → Add → OK.",
              "Готово — баланс пополнен.",
            ],
          },
        ],
      },
      {
        title: "Как купить игру в eShop",
        steps: [
          "В eShop откройте Search / Browse.",
          "Найдите нужную игру через поиск.",
          "Выберите игру → Proceed to Purchase.",
          "Для региона США при запросе zip code можно указать 97201.",
          "Подтвердите покупку — загрузка начнётся автоматически.",
        ],
      },
    ],
  },

  steam: {
    seoRegions: [
      "Steam США",
      "Steam ОАЭ",
      "Steam Бразилия",
      "Steam Чили",
      "Steam Колумбия",
      "Steam Гонконг",
      "Steam Индонезия",
      "Steam Индия",
      "Steam Корея",
      "Steam Кувейт",
      "Steam Мексика",
      "Steam Малайзия",
      "Steam Перу",
      "Steam Филиппины",
      "Steam Катар",
      "Steam Саудовская Аравия",
      "Steam Сингапур",
      "Steam Таиланд",
      "Steam Тайвань",
      "Steam Вьетнам",
      "Steam ЮАР",
    ],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "В нашем магазине вы можете быстро купить код пополнения Steam Wallet и оплатить игры, DLC, саундтреки и другой контент в Steam. Код приходит сразу после оплаты — остаётся только активировать его в клиенте или на сайте.",
          ],
          [
            "Перед покупкой проверьте валюту вашего аккаунта Steam (в правом верхнем углу магазина). Карта должна быть того же региона и той же валюты — коды Steam привязаны к региону.",
          ],
        ],
      },
      {
        title: "Подарочная карта Steam Wallet",
        paragraphs: [
          [
            "Steam Wallet Code — это 15-символьный код, который зачисляет средства на кошелёк аккаунта. Баланс можно тратить на любые покупки в Steam, пока хватает средств.",
          ],
          [
            "Код активируется только в официальном клиенте Steam или на ",
            {
              link: "https://store.steampowered.com/account/redeemwalletcode",
              text: "странице активации Steam",
            },
            ". Не передавайте код третьим лицам до активации.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        warning:
          "‼️ Регион и валюта карты должны совпадать с регионом аккаунта Steam.",
        methods: [
          {
            title: "Через клиент Steam (ПК)",
            steps: [
              "Откройте Steam и войдите в аккаунт.",
              "Нажмите на имя профиля в правом верхнем углу.",
              "Выберите «Подарочные карты».",
              "Нажмите «Активировать подарочную карту Steam» или «Активировать код кошелька».",
              "Введите 15-символьный код без пробелов → Continue.",
              "Готово — средства зачислятся на кошелёк Steam.",
            ],
          },
          {
            title: "Через сайт",
            steps: [
              [
                "Перейдите на ",
                {
                  link: "https://store.steampowered.com/account/redeemwalletcode",
                  text: "store.steampowered.com/account/redeemwalletcode",
                },
              ],
              "Войдите в нужный аккаунт Steam.",
              "Введите код пополнения кошелька и подтвердите активацию.",
            ],
          },
          {
            title: "Через мобильное приложение",
            steps: [
              "Откройте приложение Steam.",
              "Профиль → Кошелёк → Активировать подарочную карту или код кошелька.",
              "Введите код и подтвердите.",
            ],
          },
        ],
      },
    ],
  },

  playstation: {
    seoRegions: [
      "PlayStation Network США",
      "PlayStation Network Франция",
      "PlayStation Network Нидерланды",
      "PlayStation Network Португалия",
      "PlayStation Network Польша",
      "PlayStation Network Бахрейн",
      "PlayStation Network Кувейт",
      "PlayStation Network Ливан",
      "PlayStation Network Оман",
      "PlayStation Network Катар",
      "PlayStation Network ОАЭ",
      "PlayStation Network Турция",
      "PlayStation Network Бразилия",
      "PlayStation Network Канада",
      "PlayStation Network Великобритания",
      "PlayStation Network Гонконг",
      "PlayStation Network ЮАР",
    ],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Приобретайте карты пополнения PlayStation Network у нас и мгновенно пополняйте кошелёк PSN. Получайте доступ к играм, дополнениям, подпискам PS Plus и эксклюзивному контенту для PS4 и PS5.",
          ],
          [
            "Перед покупкой убедитесь, что регион аккаунта PSN совпадает с регионом карты. Коды PSN привязаны к стране аккаунта и не переносятся между регионами.",
          ],
        ],
      },
      {
        title: "Подарочная карта PlayStation Store",
        paragraphs: [
          [
            "Карта PSN содержит 12-значный код пополнения кошелька. После активации средства доступны в PlayStation Store для покупки игр, подписок и внутриигрового контента.",
          ],
          [
            "Активация доступна на консоли PS5/PS4, в приложении PlayStation App и на ",
            { link: "https://store.playstation.com/", text: "store.playstation.com" },
            ".",
          ],
        ],
      },
      {
        title: "Как активировать код",
        warning:
          "‼️ Войдите в тот аккаунт PSN, на который хотите зачислить средства.",
        methods: [
          {
            title: "На PS5",
            steps: [
              "Откройте PlayStation Store.",
              "Нажмите кнопку меню (⋯) → Redeem Code.",
              "Введите 12-значный код → Redeem → Confirm.",
            ],
          },
          {
            title: "На PS4",
            steps: [
              "Откройте PlayStation Store.",
              "Прокрутите вниз до Redeem Codes.",
              "Введите код и подтвердите активацию.",
            ],
          },
          {
            title: "Через сайт или приложение",
            steps: [
              [
                "Зайдите на ",
                { link: "https://store.playstation.com/", text: "store.playstation.com" },
                " под нужным аккаунтом.",
              ],
              "Профиль → Redeem Code.",
              "Введите код и подтвердите — баланс обновится сразу.",
            ],
          },
        ],
      },
      {
        title: "Как купить игру в PlayStation Store",
        steps: [
          "Откройте PlayStation Store на консоли, в PlayStation App или на сайте.",
          "Найдите игру через поиск и нажмите Add to Cart (или Buy).",
          "Перейдите в корзину → Checkout: оплата спишется с баланса кошелька PSN.",
          "Подтвердите покупку — игра появится в библиотеке и начнёт загружаться на консоль.",
        ],
      },
    ],
  },

  apple: {
    seoRegions: [
      "Apple Gift Card США",
      "Apple Gift Card Турция",
      "Apple Gift Card Бразилия",
    ],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Подарочные карты Apple — удобный способ пополнить баланс Apple Account и покупать приложения, игры, музыку, фильмы и подписки без привязки банковской карты.",
          ],
          [
            "Перед покупкой проверьте регион Apple ID. Карта App Store & iTunes должна быть куплена для того же региона, что и ваш аккаунт.",
          ],
        ],
      },
      {
        title: "Подарочная карта Apple Gift Card",
        paragraphs: [
          [
            "Это 16-значный код для App Store / Apple Account. Он не подходит для покупки техники в Apple Store — только для цифрового контента и подписок.",
          ],
          [
            "После активации средства добавляются на баланс Apple Account и доступны в App Store, Apple TV, Apple Music и других сервисах Apple.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        warning:
          "‼️ Используйте код, начинающийся с «X», а не серийный номер на упаковке.",
        methods: [
          {
            title: "На iPhone / iPad",
            steps: [
              "Откройте App Store.",
              "Нажмите на фото профиля → Redeem Gift Card or Code.",
              "Введите код вручную или отсканируйте камерой.",
            ],
          },
          {
            title: "На Mac",
            steps: [
              "Откройте App Store.",
              "Войдите в Apple Account → Redeem Gift Card.",
              "Введите 16-значный код и подтвердите.",
            ],
          },
          {
            title: "На Windows (iTunes)",
            steps: [
              "Откройте iTunes для Windows.",
              "Account → Redeem.",
              "Введите код и подтвердите зачисление.",
            ],
          },
        ],
      },
    ],
  },

  xbox: {
    seoRegions: [
      "Xbox Gift Card США",
      "Xbox Gift Card Турция",
      "Xbox Gift Card Бразилия",
      "Xbox Gift Card Канада",
      "Xbox Gift Card Дания",
      "Xbox Gift Card Великобритания",
      "Xbox Gift Card Гонконг",
      "Xbox Gift Card Венгрия",
      "Xbox Gift Card Норвегия",
      "Xbox Gift Card Польша",
      "Xbox Gift Card Швеция",
    ],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Карты Xbox пополняют баланс Microsoft Account — ими можно оплачивать игры, подписки Xbox Game Pass, фильмы и дополнения в Microsoft Store на Xbox и Windows.",
          ],
          [
            "Перед покупкой проверьте регион Microsoft-аккаунта. Код Xbox Gift Card должен соответствовать стране аккаунта.",
          ],
        ],
      },
      {
        title: "Подарочная карта Xbox",
        paragraphs: [
          [
            "Цифровой код из 25 символов зачисляет средства на баланс Microsoft Account после активации.",
          ],
          [
            "Баланс можно тратить в Microsoft Store online, на Xbox-консоли и в приложении Xbox на ПК.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        warning:
          "‼️ Активируйте код в том Microsoft-аккаунте, где планируете покупать.",
        methods: [
          {
            title: "Через сайт",
            steps: [
              [
                "Перейдите на ",
                { link: "https://redeem.microsoft.com/", text: "redeem.microsoft.com" },
              ],
              "Войдите в Microsoft Account.",
              "Введите 25-символьный код → Next → Confirm.",
            ],
          },
          {
            title: "На Xbox Series X|S / Xbox One",
            steps: [
              "Нажмите кнопку Xbox → Store.",
              "Use a code → введите код → подтвердите.",
            ],
          },
          {
            title: "На Windows",
            steps: [
              "Откройте Microsoft Store.",
              "Профиль → Redeem a code.",
              "Введите код и подтвердите.",
            ],
          },
        ],
      },
    ],
  },

  spotify: {
    seoRegions: ["Spotify Premium Бразилия"],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Оформите Spotify Premium через подарочный код и слушайте музыку без рекламы, с офлайн-загрузкой и улучшенным качеством звука.",
          ],
          [
            "Перед покупкой проверьте страну аккаунта Spotify — она должна совпадать со страной, для которой выпущена карта.",
          ],
        ],
      },
      {
        title: "Подарочная карта Spotify Premium",
        paragraphs: [
          [
            "Код добавляет оплаченное время подписки Premium Individual на ваш аккаунт. После окончания срока действия карты оплата продолжится обычным способом, если не отменить подписку.",
          ],
          [
            "Карты нельзя применить к тарифам Student, Duo, Family и некоторым промо-планам.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        warning:
          "‼️ Код активируется только на аккаунте Premium Individual нужного региона.",
        methods: [
          {
            title: "Через сайт",
            steps: [
              [
                "Перейдите на ",
                { link: "https://www.spotify.com/redeem", text: "spotify.com/redeem" },
              ],
              "Войдите в аккаунт Spotify.",
              "Введите код с карты → Continue → Redeem.",
            ],
          },
        ],
      },
    ],
  },

  "xbox-game-pass": {
    seoRegions: [
      "Xbox Game Pass Европа",
      "Xbox Game Pass США",
      "Xbox Game Pass Индия",
    ],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Подписки Xbox Game Pass — доступ к каталогу игр на Xbox и PC, онлайн-мультиплееру и эксклюзивам Microsoft.",
          ],
          [
            "Перед покупкой выберите тариф (Essential, Premium или Ultimate) и регион аккаунта Microsoft — код должен совпадать со страной профиля.",
          ],
        ],
      },
      {
        title: "Код подписки Xbox Game Pass",
        paragraphs: [
          [
            "После активации подписка продлевается на выбранный срок. Если у вас уже есть Game Pass, новый код добавит время к текущей подписке.",
          ],
          [
            "Ultimate включает Game Pass для консоли и PC, EA Play и другие преимущества — проверьте описание выбранного номинала.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        methods: [
          {
            title: "На Xbox",
            steps: [
              "Откройте Store на консоли.",
              "Профиль → Use a code → введите 25-значный код.",
              "Подтвердите активацию — подписка обновится автоматически.",
            ],
          },
          {
            title: "Через сайт Microsoft",
            steps: [
              [
                "Перейдите на ",
                {
                  link: "https://redeem.microsoft.com/",
                  text: "redeem.microsoft.com",
                },
              ],
              "Войдите в Microsoft Account.",
              "Введите код → Next → Confirm.",
            ],
          },
        ],
      },
    ],
  },

  fortnite: {
    seoRegions: ["Fortnite V-Bucks Европа"],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Пополняйте баланс V-Bucks для Fortnite — покупайте Battle Pass, скины, эмоции и наборы в Item Shop.",
          ],
          [
            "Код активируется в Epic Games Account. Регион карты должен соответствовать региону вашего Epic-аккаунта.",
          ],
        ],
      },
      {
        title: "Код V-Bucks",
        paragraphs: [
          [
            "После активации V-Bucks зачисляются на выбранную платформу (PC, PlayStation, Xbox и др.) в рамках вашего Epic Games аккаунта.",
          ],
          [
            "V-Bucks нельзя перенести между разными Epic-аккаунтами.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        methods: [
          {
            title: "Через сайт Epic Games",
            steps: [
              [
                "Перейдите на ",
                { link: "https://www.epicgames.com/redeem", text: "epicgames.com/redeem" },
              ],
              "Войдите в Epic Games Account.",
              "Введите код → Redeem.",
              "V-Bucks появятся в Fortnite после входа в игру.",
            ],
          },
          {
            title: "В игре Fortnite",
            steps: [
              "Откройте Fortnite.",
              "Меню → V-Bucks → Redeem Code.",
              "Введите код и подтвердите.",
            ],
          },
        ],
      },
    ],
  },

  roblox: {
    seoRegions: [
      "Roblox США",
      "Roblox Европа",
      "Roblox Бразилия",
      "Roblox Саудовская Аравия",
    ],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Подарочные карты Roblox позволяют получить Robux — внутриигровую валюту для покупки аватаров, пропусков и платного контента в играх Roblox.",
          ],
          [
            "Перед покупкой проверьте регион карты. Код должен соответствовать региону вашего Roblox-аккаунта.",
          ],
        ],
      },
      {
        title: "Подарочная карта Roblox",
        paragraphs: [
          [
            "После активации Robux зачисляются на баланс аккаунта Roblox и доступны сразу в игре и на сайте.",
          ],
          [
            "Код одноразовый — активируйте его только на своём аккаунте.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        methods: [
          {
            title: "Через сайт",
            steps: [
              [
                "Перейдите на ",
                { link: "https://www.roblox.com/redeem", text: "roblox.com/redeem" },
              ],
              "Войдите в аккаунт Roblox.",
              "Введите PIN-код с карты → Redeem.",
            ],
          },
          {
            title: "В приложении Roblox",
            steps: [
              "Откройте Roblox → More → Redeem Card.",
              "Введите код и подтвердите.",
            ],
          },
        ],
      },
    ],
  },

  "nintendo-membership": {
    seoRegions: [
      "Nintendo Switch Online Европа",
      "Nintendo Switch Online Великобритания",
      "Nintendo Switch Online Бразилия",
      "Nintendo Switch Online Гонконг",
      "Nintendo Switch Online Мексика",
      "Nintendo Switch Online Польша",
      "Nintendo Switch Online Швеция",
    ],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Nintendo Switch Online — подписка для онлайн-игры, облачных сохранений и доступа к каталогу классических игр NES, SNES и Game Boy.",
          ],
          [
            "Выберите Individual (для одного аккаунта) или Family (до 8 аккаунтов) и срок подписки. Регион кода должен совпадать с регионом Nintendo Account.",
          ],
        ],
      },
      {
        title: "Код подписки Nintendo Switch Online",
        paragraphs: [
          [
            "После активации подписка начинает действовать сразу или продлевает текущий период, если у вас уже есть Nintendo Switch Online.",
          ],
          [
            "Family-подписка позволяет добавить до 7 дополнительных участников в семейную группу Nintendo.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        methods: [
          {
            title: "На Nintendo Switch",
            steps: [
              "Откройте Nintendo eShop.",
              "Профиль → Enter Code → введите код.",
              "Подтвердите активацию — подписка появится в разделе Nintendo Switch Online.",
            ],
          },
          {
            title: "Через сайт Nintendo",
            steps: [
              [
                "Перейдите на ",
                {
                  link: "https://ec.nintendo.com/redeem",
                  text: "ec.nintendo.com/redeem",
                },
              ],
              "Войдите в Nintendo Account.",
              "Введите код и подтвердите.",
            ],
          },
        ],
      },
    ],
  },

  riot: {
    seoRegions: [
      "Riot Access Европа",
      "Riot Access США",
      "Riot Access Турция",
      "Riot Access Канада",
    ],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Карты Riot Access пополняют Riot Points (RP) для League of Legends, VALORANT, Teamfight Tactics и других проектов Riot Games.",
          ],
          [
            "Перед покупкой выберите карту нужной игры и региона. RP-код VALORANT не активируется в League of Legends и наоборот.",
          ],
        ],
      },
      {
        title: "Код Riot Access",
        paragraphs: [
          [
            "PIN-код зачисляет RP на Riot Account после выбора игры при активации. Средства можно тратить в магазине выбранной игры.",
          ],
          [
            "Код привязан к региону — US-карта активируется только на североамериканском аккаунте, EU — на европейском.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        warning:
          "‼️ Выберите игру при активации — код нельзя разделить между несколькими играми.",
        methods: [
          {
            title: "Через сайт Riot",
            steps: [
              [
                "Перейдите на ",
                { link: "https://shop.riotgames.com/redeem", text: "shop.riotgames.com/redeem" },
              ],
              "Войдите в Riot Account.",
              "Введите PIN без пробелов → Redeem Code.",
              "Выберите игру (VALORANT, LoL и т.д.) → Confirm.",
            ],
          },
          {
            title: "В клиенте VALORANT",
            steps: [
              "Откройте VALORANT.",
              "Нажмите на иконку VP → Prepaid Cards & Codes.",
              "Введите код → Submit.",
            ],
          },
          {
            title: "В League of Legends",
            steps: [
              "Откройте клиент LoL → Store.",
              "Account → Redeem Codes.",
              "Введите код → Submit.",
            ],
          },
        ],
      },
    ],
  },

  pubg: {
    seoRegions: ["PUBG Mobile UC США"],
    sections: [
      {
        title: "Описание",
        paragraphs: [
          [
            "Покупайте UC (Unknown Cash) для PUBG Mobile — внутриигровую валюту для Royal Pass, наборов и косметики.",
          ],
          [
            "Код активируется в игре или через официальный сервис пополнения. Регион карты должен совпадать с регионом игрового аккаунта.",
          ],
        ],
      },
      {
        title: "Код UC для PUBG Mobile",
        paragraphs: [
          [
            "После активации UC зачисляются на аккаунт PUBG Mobile, привязанный к вашему Player ID.",
          ],
          [
            "Код одноразовый. Не передавайте его третьим лицам до активации.",
          ],
        ],
      },
      {
        title: "Как активировать код",
        warning:
          "‼️ Убедитесь, что вводите Player ID правильного аккаунта PUBG Mobile.",
        methods: [
          {
            title: "В игре PUBG Mobile",
            steps: [
              "Откройте PUBG Mobile.",
              "Нажмите на иконку UC → Redeem / Пополнение.",
              "Введите код → Confirm.",
              "UC появятся на балансе сразу после успешной активации.",
            ],
          },
          {
            title: "Через официальный сервис пополнения",
            steps: [
              [
                "Откройте ",
                { link: "https://www.midasbuy.com/midasbuy/pubgm", text: "Midasbuy PUBG Mobile" },
                " (или другой официальный партнёр для вашего региона).",
              ],
              "Введите Player ID.",
              "Выберите Redeem Code и введите полученный код.",
            ],
          },
        ],
      },
    ],
  },
};

export function getOtherStoreGuide(storeId) {
  return OTHER_STORE_GUIDES[storeId] ?? null;
}
